export default "__VITE_ASSET__CgMEnQLp__"